import { render } from "./QuestPuzzleDetails.vue?vue&type=template&id=688569ea&scoped=true"
import script from "./QuestPuzzleDetails.vue?vue&type=script&lang=js"
export * from "./QuestPuzzleDetails.vue?vue&type=script&lang=js"

import "./QuestPuzzleDetails.vue?vue&type=style&index=0&id=688569ea&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688569ea"]])

export default __exports__